export default {
  CARD: 'card',
  MODAL: 'modal',
  GEN: 'gen',
};
